(() => {
  function initializeSection(section) {
    if (!section || section.dataset.featuredCollection2Initialized === 'true') return;

    const carousel = section.querySelector('[data-carousel]');
    const leftButton = section.querySelector('[data-scroll-left]');
    const rightButton = section.querySelector('[data-scroll-right]');

    if (!carousel || !leftButton || !rightButton) return;

    section.dataset.featuredCollection2Initialized = 'true';
    const loopSlides = true;
    let activeIndex = 0;
    let settleTimeoutId;

    const scrollPaddingLeft = () => {
      const value = window.getComputedStyle(carousel).scrollPaddingLeft;
      return Number.parseFloat(value) || 0;
    };

    const slidePositions = () =>
      Array.from(carousel.querySelectorAll('.featured-collection-2__item')).map((item) =>
        Math.max(0, item.offsetLeft - scrollPaddingLeft())
      );

    const getStops = () => {
      const maxScrollLeft = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      const normalized = slidePositions().map((position) => Math.min(position, maxScrollLeft));
      const unique = Array.from(new Set(normalized));
      return unique.sort((a, b) => a - b);
    };

    const closestIndex = (stops) => {
      if (!stops.length) return 0;
      const currentLeft = carousel.scrollLeft;
      return stops.reduce((closestStopIndex, stop, index) => {
        const closestDistance = Math.abs(stops[closestStopIndex] - currentLeft);
        const distance = Math.abs(stop - currentLeft);
        return distance < closestDistance ? index : closestStopIndex;
      }, 0);
    };

    const syncActiveIndex = (stops = getStops()) => {
      if (!stops.length) {
        activeIndex = 0;
        return stops;
      }

      activeIndex = closestIndex(stops);
      return stops;
    };

    const updateButtons = () => {
      const stops = getStops();
      const canSlide = stops.length > 1;

      if (!canSlide) {
        leftButton.disabled = true;
        rightButton.disabled = true;
        leftButton.classList.add('is-inactive');
        rightButton.classList.add('is-inactive');
        return;
      }

      const currentIndex = closestIndex(stops);
      const atStart = currentIndex <= 0;
      const atEnd = currentIndex >= stops.length - 1;

      if (loopSlides) {
        leftButton.disabled = false;
        rightButton.disabled = false;
      } else {
        leftButton.disabled = atStart;
        rightButton.disabled = atEnd;
      }

      leftButton.classList.toggle('is-inactive', atStart);
      rightButton.classList.toggle('is-inactive', atEnd);
    };

    const scrollByItem = (direction) => {
      const stops = getStops();
      if (stops.length <= 1) return;

      syncActiveIndex(stops);

      let targetIndex = activeIndex;
      if (direction > 0) {
        targetIndex = loopSlides ? (activeIndex + 1) % stops.length : Math.min(activeIndex + 1, stops.length - 1);
      } else {
        targetIndex = loopSlides ? (activeIndex - 1 + stops.length) % stops.length : Math.max(activeIndex - 1, 0);
      }

      activeIndex = targetIndex;
      carousel.scrollTo({ left: stops[targetIndex], behavior: 'smooth' });
    };

    const handleScroll = () => {
      window.clearTimeout(settleTimeoutId);
      settleTimeoutId = window.setTimeout(() => {
        syncActiveIndex();
        updateButtons();
      }, 120);
    };

    leftButton.addEventListener('click', () => scrollByItem(-1));
    rightButton.addEventListener('click', () => scrollByItem(1));
    carousel.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', () => {
      syncActiveIndex();
      updateButtons();
    });

    syncActiveIndex();
    updateButtons();
  }

  function initializeAll() {
    document.querySelectorAll('[data-featured-collection-2-section]').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
